export class ADUser
{
    mail: string;
    displayName: string;
}
